<template>
  <vue-final-modal
    :value="visible"
    name="yagiprime-payment-dialog"
    :classes="['yagiprime-payment-dialog__container']"
    :content-class="[
      'yagiprime-payment-dialog__content',
      'v--modal-box',
      'v--modal',
      'payment-modal'
    ]"
    :click-to-close="true"
    :esc-to-close="true"
    :lock-scroll="true"
    attach="body"
    @input="onVisibleInput"
  >
    <div
      class="payment-modal__close"
      v-loading.fullscreen.lock="fullscreenLoading"
    >
      <el-button
        @click="closePaymentDialog"
        icon="el-icon-circle-close"
        class="payment-modal__close-btn"
        type="text"
      ></el-button>
    </div>

    <div class="payment-content" v-if="permissionType == 1">
      <p class="payment-content__tip">ヤギプライム</p>
      <h2 class="payment-content__heading">履歴書作成から面接対策まで！</h2>

      <img
        src="/static/renew2_img/prime-list-freelance-sp.jpg"
        alt="証明写真風加工で背景透過、自分の個性UPする限定フォント解放、AIが志望動機・自己PRを自動作成、AI面接官といつでも面接練習、ヤギオファー検索で上位表示、請求書・見積書などの保存数・フォルダ分け"
        class="payment-content__image sp"
      />
      <img
        src="/static/renew2_img/prime-list-freelance-pc.jpg"
        alt="証明写真風加工で背景透過、自分の個性UPする限定フォント解放、AIが志望動機・自己PRを自動作成、AI面接官といつでも面接練習、ヤギオファー検索で上位表示、請求書・見積書などの保存数・フォルダ分け"
        class="payment-content__image pc"
      />

      <p class="payment-attention">
        Yagishの<a href="/terms" class="payment-link" target="_blank"
          >利用規約</a
        >、
        <a href="/privacy" class="payment-link" target="_blank"
          >個人情報の取り扱いについて</a
        >、
        <img
          src="/static/renew3_img/carat_img/caratcheck_icon.svg"
          alt="チェック"
          class="payment-icon"
        />
        <a href="/yagiprimeterms" class="payment-link" target="_blank"
          >ヤギプライム利用規約</a
        >に同意の上、ヤギプライムにご登録ください。
      </p>

      <p class="payment-price">
        <span v-if="selectedIndex === 2" class="payment-price__discount"
          >18%割引<br
        /></span>
        <!-- 紹介キャンペーン等で無料期間が付く加入。日数の正本はサーバー
             （status API の pending_days_total）で、ここは表示するだけ -->
        <template v-if="effectiveFreeDays > 0">
          <span class="payment-price__strike">{{ price }}円/{{ dates }}日</span>
          <span class="payment-price__amount"
            >{{ effectiveFreeDays }}日間無料</span
          ><br />
          <span class="payment-price__note"
            >無料期間終了後は{{ price }}円/{{ dates }}日で自動更新</span
          ><br />
        </template>
        <template v-else>
          <span class="payment-price__amount">{{ price }}</span
          >円/{{ dates }}日<br />
          <span class="payment-price__note">30日ごとに自動更新</span><br />
        </template>
        <span v-if="selectedIndex === 3" class="payment-price__note"
          >新卒テンプレート利用者のみ対象</span
        >

        <!-- 紹介キャンペーンの適用状況。紹介する側にはまだ 0 件でも出す。
             被紹介者には件数を出さず、無料期間が付くときだけ期限を出す -->
        <span class="payment-price__referral" v-if="showReferralNotice">
          <span class="payment-price__referral-heading">{{
            referralNotice.heading
          }}</span>
          <span class="payment-price__referral-body"
            >{{ referralNotice.before
            }}<a :href="referralNotice.cancelPath" class="payment-link">{{
              referralNotice.cancelLabel
            }}</a
            >{{ referralNotice.after }}</span
          >
        </span>
      </p>

      <div class="payment-section">
        <h3 class="payment-section__title payment-section__title--highlight">
          通知設定
        </h3>
        <p class="payment-attention">
          ヤギプライム内のサービスであるAIによる求人レコメンドのメール配信やそのほかお客様へおすすめする情報をお送りします。
        </p>
        <ul class="notification-list">
          <li class="notification-list__item">
            <input
              type="radio"
              id="notification-on-dialog"
              name="notification-dialog"
              value="on"
              v-model="notificationSetting"
              class="notification-list__input"
            />
            <label for="notification-on-dialog" class="notification-list__label"
              >受信する<span class="notification-list__label-highlight"
                >（推奨）</span
              ></label
            >
          </li>
          <li class="notification-list__item">
            <input
              type="radio"
              id="notification-off-dialog"
              name="notification-dialog"
              value="off"
              v-model="notificationSetting"
              class="notification-list__input"
            />
            <label
              for="notification-off-dialog"
              class="notification-list__label"
              >受信しない</label
            >
          </li>
        </ul>
      </div>
    </div>

    <div class="payment-section">
      <h3 class="payment-section__title payment-section__title--highlight">
        お支払い方法
      </h3>
      <PaymentForm
        :serviceName="serviceName"
        :price="price"
        :is_subscription="true"
        :selectedIndex="selectedIndex"
        :notificationSetting="notificationSetting"
      />
    </div>

    <div class="payment-footer">
      <el-button @click="closePaymentDialog">閉じる</el-button>
    </div>

    <CreateFormatDialog ref="createFormatDialog" />
  </vue-final-modal>
</template>

<script setup lang="ts">
/**
 * ヤギプライム課金ダイアログ（vue-final-modal）。
 * open は mitt（show/open-yagiprime-payment-dialog）。hide は既存 mitt。
 */
import axios from 'axios'
import {
  computed,
  getCurrentInstance,
  onBeforeMount,
  onBeforeUnmount,
  ref
} from 'vue'
import { useEventListener } from '@vueuse/core'
import { useAuth } from '@/composables/useAuth'
import { AUTH_STATE_CHANGED, emitter } from '@/plugins/emitter'
import PaymentForm from '@/components/Payment/PaymentMethodSelector.vue'
import CreateFormatDialog from '@/components/CreateFormatDialog.vue'
import { useReferralStatus } from '@/composables/yagiprime/useReferralStatus'
import {
  fillTemplate,
  formatFreeUntilLabel
} from '@/utils/yagiprime/referralCampaign'
import campaign from '@/utils/yagiprime/referralCampaign.json'

const OPEN_YAGIPRIME_PAYMENT_DIALOG = 'open-yagiprime-payment-dialog'
const SHOW_YAGIPRIME_PAYMENT_DIALOG = 'show-yagiprime-payment-dialog'
const HIDE_YAGIPRIME_PAYMENT_DIALOG = 'hide-yagiprime-payment-dialog'
const PAYMENT_YAGIPRIME_RESULT = 'payment_yagiprime_result'
const YAGIPRIME_PAYMENT_SUCCESS = 'yagiprime-payment-success'

type HostVm = {
  $deviceLib: { isMobileDevice: boolean }
  $varuna: { endPoints: Record<string, string> }
  $message: (opts: Record<string, unknown>) => void
}

type CreateFormatDialogExpose = {
  openDialog: () => void
}

const props = defineProps({
  /**
   * 加入時に無料になる日数。0 なら通常の価格表示。
   * 紹介キャンペーンのように無料期間が付く導線だけが値を渡す。
   * 実際に trial_end へ乗るのはサーバー側の計算なので、ここは表示専用。
   */
  freeDays: {
    type: Number,
    required: false,
    default: 0
  }
})

const vm = getCurrentInstance()!.proxy as unknown as HostVm
const { user, getClient } = useAuth()

const visible = ref(false)
const permissionType = ref(1)
const fullscreenLoading = ref(false)
const serviceName = ref('ヤギプライム')
const price = ref(550)
const dates = ref(30)
const selectedIndex = ref(1)
const hasRequiredFormat = ref(true)
const notificationSetting = ref('on')
const createFormatDialog = ref<CreateFormatDialogExpose | null>(null)

// 紹介キャンペーンの無料適用。日数の正本はサーバーで、ここは申込前の見込み表示
const {
  refreshStatus,
  clickCount,
  signupCount,
  successCount,
  pendingDaysTotal,
  isReferee
} = useReferralStatus()

/**
 * 実際に適用される無料日数。呼び出し側が渡していれば props を優先し
 * （被紹介者バナーはその値で開く）、無ければ status API の合計を使う。
 */
const effectiveFreeDays = computed(() =>
  props.freeDays > 0 ? props.freeDays : pendingDaysTotal.value
)

/** 期間が終わったら注記ごと消す（JSON の isActive が正本） */
const isCampaignActive = campaign.isActive

/**
 * 注記を出すか。被紹介者は紹介する側になれないので、無料日数が付かないなら
 * 書くことが何も無い（紹介者向けの「成立するとどうなるか」は当てはまらない）。
 */
const showReferralNotice = computed(
  () => isCampaignActive && (!isReferee.value || effectiveFreeDays.value > 0)
)

/**
 * 価格枠に出す注記。リンク（解約ページ）の前後で分けて組み立てる。
 * まだ無料適用が無い人にも件数 0 のまま出すが、本文は「成立するとどうなるか」の
 * 文に差し替える（無料期限が無いのに日付を書かないため）。
 *
 * 被紹介者には件数・成立上限を含まない bodyReferee を出す。本人は紹介する側に
 * なれないため「0クリック、0紹介成立のため無料」という因果のねじれた文になり、
 * 「マイページで無料期間の更新を確認できる」も当てはまらない。
 */
const referralNotice = computed(() => {
  const notice = campaign.paymentNotice
  const body = isReferee.value
    ? notice.bodyReferee
    : effectiveFreeDays.value > 0
      ? notice.body
      : notice.bodyNoFreeDays
  const filled = fillTemplate(body, {
    click: clickCount.value ?? 0,
    signup: signupCount.value ?? 0,
    success: successCount.value,
    until: formatFreeUntilLabel(effectiveFreeDays.value),
    limit: campaign.offer.maxReferralCount,
    daysPerReferral: campaign.offer.freeDaysPerReferral,
    price: campaign.offer.monthlyPriceTaxIncludedYen,
    cycle: campaign.offer.billingCycleDays
  })
  const [before, after] = filled.split('{cancel}')
  return {
    heading: notice.heading,
    before,
    after: after ?? '',
    cancelLabel: notice.cancelLabel,
    cancelPath: notice.cancelPath
  }
})

function currentUid(): string {
  return getClient()?.user?.uid ?? user.value?.uid ?? ''
}

function currentEmail(): string {
  return getClient()?.user?.email ?? user.value?.email ?? ''
}

function currentEmailVerified(): boolean {
  const u = getClient()?.user ?? user.value
  return !!(u && 'emailVerified' in u && u.emailVerified)
}

function onVisibleInput(value: boolean) {
  visible.value = value
}

function openPaymentDialog() {
  visible.value = true
  // 開くたびに取り直す。紹介が成立して無料日数が増えていても、キャッシュの
  // ままだと古い「◯日間無料」で課金条件を案内することになる
  refreshStatus()
  emitter.emit('change-loading-text', 'ヤギプライム登録中...')
  selectCard(1)
}

function closePaymentDialog() {
  visible.value = false
}

function selectCard(index: number) {
  selectedIndex.value = index

  if (index === 1) {
    price.value = 550
    dates.value = 30
  } else if (index === 2) {
    price.value = 1350
    dates.value = 90
  } else if (index === 3) {
    price.value = 550
    dates.value = 30
  }

  if (index !== 3) return

  try {
    const formData = new FormData()
    formData.append('uuid', currentUid())
    formData.append('version', '2')
    formData.append('reqflg', '2')
    formData.append('email', currentEmail())
    formData.append('site_flag', 'r')
    formData.append('device_flag', vm.$deviceLib.isMobileDevice ? 'SP' : 'PC')
    formData.append('email_verified', currentEmailVerified() ? '1' : '0')

    axios
      .post(vm.$varuna.endPoints.getMypageHistory, formData, {
        timeout: 60000
      })
      .then((response) => {
        const history = response.data.format_ids as Array<{ format_id: string }>
        const requiredFormats = [
          'rirekisho_job_new',
          'rirekisho_job_new_single',
          'internship',
          'entrysheet'
        ]
        const formatExists = requiredFormats.some((format) =>
          history.some((item) => item.format_id === format)
        )
        if (!formatExists) {
          hasRequiredFormat.value = false
          createFormatDialog.value?.openDialog()
        }
      })
      .catch((error) => {
        console.error('フォーマットチェックに失敗しました:', error)
      })
  } catch (error) {
    console.error('フォーマットチェックに失敗しました:', error)
  }
}

async function authStateChanged() {
  const uid = currentUid()
  if (!uid) return
  try {
    const response = await axios.get(
      vm.$varuna.endPoints.isSubscribed + uid + '/',
      { timeout: 60000 }
    )
    if (response.data.is_subscribed) {
      visible.value = false
      emitter.emit(YAGIPRIME_PAYMENT_SUCCESS)
    }
  } catch {
    // ignore
  } finally {
    fullscreenLoading.value = false
  }
}

function onPaymentYagiprimeResult(result: unknown) {
  fullscreenLoading.value = false
  if (
    result === 'error' ||
    (result &&
      typeof result === 'object' &&
      (result as { status?: string }).status === 'error')
  ) {
    let errorMessage = '決済失敗しました'
    if (
      result &&
      typeof result === 'object' &&
      (result as { message?: string }).message
    ) {
      errorMessage = (result as { message: string }).message
    }
    vm.$message({
      message: errorMessage,
      type: 'error'
    })
  } else if (
    result === 'success' ||
    (result &&
      typeof result === 'object' &&
      (result as { status?: string }).status === 'success')
  ) {
    vm.$message({
      message: '決済完了しました',
      type: 'success'
    })
  }
}

function onLoadingOff() {
  fullscreenLoading.value = false
}

useEventListener(window, 'popstate', closePaymentDialog)

onBeforeMount(() => {
  emitter.on(OPEN_YAGIPRIME_PAYMENT_DIALOG, openPaymentDialog)
  emitter.on(SHOW_YAGIPRIME_PAYMENT_DIALOG, openPaymentDialog)
  emitter.on(HIDE_YAGIPRIME_PAYMENT_DIALOG, closePaymentDialog)
  emitter.on(AUTH_STATE_CHANGED, authStateChanged)
  emitter.on(PAYMENT_YAGIPRIME_RESULT, onPaymentYagiprimeResult)
  emitter.on('loading_off', onLoadingOff)
})

onBeforeUnmount(() => {
  emitter.off(OPEN_YAGIPRIME_PAYMENT_DIALOG, openPaymentDialog)
  emitter.off(SHOW_YAGIPRIME_PAYMENT_DIALOG, openPaymentDialog)
  emitter.off(HIDE_YAGIPRIME_PAYMENT_DIALOG, closePaymentDialog)
  emitter.off(AUTH_STATE_CHANGED, authStateChanged)
  emitter.off(PAYMENT_YAGIPRIME_RESULT, onPaymentYagiprimeResult)
  emitter.off('loading_off', onLoadingOff)
})
</script>

<style
  lang="scss"
  src="@/assets/scss/payment/yagiprime-payment-dialog.scss"
></style>

<style lang="scss">
// 中央寄せは __container 側（.vfm に :styles で flex を渡すと幅が縮む）。
// align-items:center だと高いコンテンツの上が切れスクロール不能になるため、
// flex-start + content の margin-block:auto で短いときだけ縦中央にする。
.yagiprime-payment-dialog__container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 16px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 1001;
}

.yagiprime-payment-dialog__content.v--modal-box.v--modal {
  position: relative;
  box-sizing: border-box;
  flex: 0 0 auto;
  width: calc(100% - 32px);
  max-width: 600px;
  height: auto;
  margin-block: auto;
  border-radius: 8px;
  padding: 20px;
}
</style>
